export type ButtonType =
  | 'YES'
  | 'NO'
  | 'CANCEL'
  | 'OK'
  | 'CLOSE'
  | 'CLEAR'
  | 'DELETE'
  | 'SAVE'
  | 'CONFIRM'
  | 'CREATE'
  | 'APPLY'
  | 'RESET'
  | 'APPROVE'
  | 'DECOMMISSION'
  | 'INITIATE_OTAP'
  | 'FORCE_INITIATE_OTAP'
  | 'LEAVE'
  | 'OBSOLETE'

export const BUTTON_TYPE = {
  YES: 'YES' as ButtonType,
  NO: 'NO' as ButtonType,
  CANCEL: 'CANCEL' as ButtonType,
  OK: 'OK' as ButtonType,
  CLOSE: 'CLOSE' as ButtonType,
  CLEAR: 'CLEAR' as ButtonType,
  DELETE: 'DELETE' as ButtonType,
  SAVE: 'SAVE' as ButtonType,
  CONFIRM: 'CONFIRM' as ButtonType,
  APPLY: 'APPLY' as ButtonType,
  RESET: 'RESET' as ButtonType,
  APPROVE: 'APPROVE' as ButtonType,
  DECOMMISSION: 'DECOMMISSION' as ButtonType,
  INITIATE_OTAP: 'INITIATE_OTAP' as ButtonType,
  FORCE_INITIATE_OTAP: 'FORCE_INITIATE_OTAP' as ButtonType,
  LEAVE: 'LEAVE' as ButtonType,
  CREATE: 'CREATE' as ButtonType,
  OBSOLETE: 'OBSOLETE' as ButtonType
}
